import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const IAMTemplateLibrary = lazy(() =>
  import("@scenes/MessageComposition/InAppMessage/Templates/IamTemplateLibrary").then((module) => ({
    default: module.IAMTemplateLibrary,
  }))
);

export const inAppColorProfilesNRO: NavigationRoutingObject = {
  Component: IAMTemplateLibrary,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("in-app-message-templates", "In-App Message Templates"),
  pageNameForTracking: () => "In-App Message Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("in-app-message-templates-nav", "Create and manage custom message templates and color profiles"),
  icon: "nav-system-in-app-message-templates",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    if (!featureOn("iam")) {
      return false;
    }
    return hasPermission("appGroupOrAnyTeamInAppGroup", {
      permission: "viewIamTemplates",
    });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("in-app-message-templates-alt-keyword-1", "IAM Templates")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/engagement/templates_and_media/in_app_message_color_profiles/:appGroupId",
};
